/**
    @function awl_transition_exec
    @param node - vanilla.js DOM Element (see vanilla.js sources for docs)
    @param class1 - transition init classes
    @param class2 - transition start classes
    @param bRemoveClasses - cleanup classes after transition
    @param onTransition - callback called before transition started (after class2 set)
    @returns {Promise}
*/
export function awl_transition_exec(
    node: HTMLElement,
    class1: string,
    class2: string,
    bRemoveClasses: boolean = false,
    onTransition: Function | null = null,
    animationMode: boolean = false
): Promise<void> {
    return new Promise((resolve, _reject) => {
        let tr_started: boolean = false;
        const classes1: string[] = class1.split(/\s+/).filter(function (n) {
            return !!n;
        });
        const classes2: string[] = class2.split(/\s+/).filter(function (n) {
            return !!n;
        });
        function tr_end() {
            if (tr_started) {
                tr_started = false;
                if (bRemoveClasses) {
                    classes1.forEach(function (cls) {
                        node.classList.remove(cls);
                    });
                    classes2.forEach(function (cls) {
                        node.classList.remove(cls);
                    });
                }
                node.removeEventListener(animationMode ? 'animationend' : 'transitionend', tr_end);
                node.removeEventListener(animationMode ? 'webkitAnimationend' : 'webkitTransitionend', tr_end);
                resolve();
            }
        }
        classes1.forEach(function (cls) {
            node.classList.add(cls);
        });
        node.addEventListener(animationMode ? 'animationend' : 'transitionend', tr_end);
        node.addEventListener(animationMode ? 'webkitAnimationend' : 'webkitTransitionend', tr_end);
        window.setTimeout(function () {
            tr_started = true;
            classes2.forEach(function (cls) {
                node.classList.add(cls);
            });
            if (onTransition !== null) {
                onTransition();
            }
        }, 0);
    });
    //	return $$.promise;
}
